/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon } from 'semantic-ui-react'
import { useContext } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { UltyModalWrapperContext } from '../../../Shared/UltyModalWrapper/UltyModalWrapperContext'
import { AisleDetail } from './AisleDetail'
import { useDeviceMediaQuery } from '../../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'

const Aisle = ({aisle, onChange, isDragging = false, onMoveToWithdrawn, ...props}) => {
    const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id: props.id})
    const {handleUltyModalWrapper} = useContext(UltyModalWrapperContext)
    const {isMobile} = useDeviceMediaQuery()

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.3 : undefined,
        position: 'relative',
    }

    const openAisleDetailModal = () => {
        if (!aisle.aisles) return

        handleUltyModalWrapper(true, {
            component: <AisleDetail aisle={aisle} onUpdate={onChange}/>,
            header: aisle.name,
            size: 'huge',
        })
    }

    const handleMoveToWithdrawn = (e) => {
        e.preventDefault()
        e.stopPropagation()
        onMoveToWithdrawn?.(props.id)
    }

    const handleViewDetails = (e) => {
        e.preventDefault()
        e.stopPropagation()
        openAisleDetailModal()
    }

    return (
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        css={css`
            margin: ${isMobile ? '0.5rem' : '1rem'};
            border: 1px solid ${isDragging ? '#00b5ad' : 'lightgray'};
            border-radius: 5px;
            background-color: white;
            ${isDragging && 'box-shadow: inset 0 0 0 2px #00b5ad;'}
        `}
      >
          <div
            {...listeners}
            className="aisle-header"
            css={css`
                display: flex;
                align-items: center;
                justify-content: space-between;
                cursor: grab;
                font-weight: bold;
                width: 100%;
                background-color: ${isDragging ? '#e6f7f7' : 'white'};
                border: 1px solid grey;
                padding: ${isMobile ? '0.75rem 0.5rem' : '1rem .75rem'};
                min-height: ${isMobile ? '4rem' : '6rem'};
            `}
          >
              <div css={css`
                  display: flex;
                  align-items: baseline;
                  font-size: 1rem;
              `}>
                  {aisle.name}
              </div>

              <div css={css`
                  display: flex !important;
                  flex-direction: ${isMobile ? 'row' : 'column'};
                  gap: ${isMobile ? '8px' : '12px'};
                  align-items: center;
                  min-width: ${isMobile ? '60px' : 'auto'};
                  justify-content: flex-end;
              `}>
                  {aisle.aisles && (
                    <Icon
                      name="folder open"
                      color="teal"
                      size="large"
                      onClick={handleViewDetails}
                      css={css`
                          &.icon {
                              margin-left: 0.20rem;
                              cursor: pointer;
                          }
                      `}
                    />
                  )}

                  {onMoveToWithdrawn && (
                    <Icon
                      name="minus circle"
                      size="large"
                      css={css`
                          &.icon {
                              color: lightgray;
                              cursor: pointer;
                          }
                      `}
                      onClick={handleMoveToWithdrawn}
                    />
                  )}
              </div>
          </div>
      </div>
    )
}

export { Aisle }
